export default 'V00_016_70'
